/**
 * Roles that sign in without `custom:business_id`:
 * - `business_property_manager`: works through its assigned estates.
 * - `business_invitation_all` (tenant Front Desk): a tenant role that works across every business.
 * - `estate_group_admin`, `estate_group_front_desk` (SAM-1108, M7): scoped by `custom:estate_group_ids` instead.
 * - `admin`, `xhinola_admin`: the tenant Admin is a tenant role, not tied to one business.
 * Everyone else must belong to a business, or the admin refuses the session.
 */
export const NO_BUSINESS_ROLES = [
  'business_property_manager', 'business_invitation_all', 'estate_group_admin', 'estate_group_front_desk',
  'admin', 'xhinola_admin',
] as const;

export const canSignInWithoutBusiness = (groups: readonly string[] | undefined | null): boolean =>
  !!groups && NO_BUSINESS_ROLES.some((g) => groups.includes(g));
